// extracted by mini-css-extract-plugin
export default {"maincontainer":"layout_maincontainer__9W2re","nextcontainer":"layout_nextcontainer__osxrU"};